import fetch from 'isomorphic-fetch';

export default async (endPoint, headers = {}) => {
  const response = await fetch(endPoint, {
    headers,
  });
  const responseJSON = await response.json();
  return new Promise((resolve, reject) => {
    // Check if there is error in the responseData
    try {
      const responseData = responseJSON;
      const { success } = responseData;
      if (success) {
        resolve(responseData);
      }
      else {
        const {
          errors,
        } = responseData;
        // In case of error, reject with returning error and errorCode
        reject({ errors });
      }
    } catch (ex) {
      reject();
    }
  });
};

export const externalRequestGet = async (endpoint, headers = {}) => {
  const response = await fetch(endpoint, {
    headers,
  });
  const responseJSON = await response.json();
  return new Promise((resolve, reject) => {
    // Check if there is error in the responseData
    try {
      const responseData = responseJSON;
      resolve(responseData);
    } catch (ex) {
      reject();
    }
  });
};
